<div class="container section">
    <div class="row">
        <div class="pagetitle">
            <h1 class="chapters">Chapters</h1>
        </div>
    </div>

    <form class="full-width" novalidate="novalidate" (ngSubmit)="save()" [formGroup]="addressesForm">
        <h3>Change Chapter</h3>

        <p>
            Please update your address to change or add a new chapter.
        </p>

        <div class="row">
            <div class="col-sm-6">
                <h3>Home Address</h3>
            </div>

            <div class="col-sm-6">
                <mat-radio-button class="primary" color="primary" (change)="changePrimary($event)" [checked]="home.get('isprimary').value" value="Home">Primary Address</mat-radio-button>
            </div>
        </div>

        <app-address [address]="homeAddress" #homeAddressComp></app-address>

        <!-- <div class="row">
      <div class="col-sm-6">
        <h3>Hospital Address</h3>
      </div>

      <div class="col-sm-6">
        <mat-radio-button class="primary" color="primary" (change)="changePrimary($event)"  [checked]="hospital.get('isprimary').value" value="Hospital" >Primary Address</mat-radio-button>
      </div>
    </div>

    <app-address [address]="hospitalAddress" #hospAddressComp></app-address> -->

        <div class="row">
            <div class="col-sm-6">
                <h3>Business Address</h3>
            </div>

            <div class="col-sm-6">
                <mat-radio-button class="primary" color="primary" (change)="changePrimary($event)" [checked]="business.get('isprimary').value" value="Business">Primary Address</mat-radio-button>
            </div>
        </div>

        <app-address [address]="businessAddress" #busAddressComp></app-address>

        <div class="row margin-top-60">
            <div class="col-lg-12">
                <button type="button" mat-raised-button="mat-raised-button" class="greyBtn" (click)="cancel()">Cancel</button>
                <button class="pull-right" color="primary" mat-raised-button="mat-raised-button">Save</button>
            </div>
        </div>
    </form>

    <pre *ngIf="isDevEnv">
      <code>{{addressesForm.value | json}}</code>
    </pre>

</div>